export default function Business() {
  const businesses = [
    {
      title: 'ENCHANT',
      subtitle: 'Hair & Makeup Specialist',
      description: 'We provide professional hair and makeup services for all occasions, from entertainment and fashion to artistic and everyday makeup.',
      icon: 'ri-scissors-cut-line',
      image: 'https://static.readdy.ai/image/6902dd986b6e328bf9bb68047035d84f/69fdeed212904b6617d42fccd47e3dc8.png',
      features: ['Entertainment Makeup', 'Fashion Makeup', 'Artist Makeup', 'Daily Makeup']
    },
    {
      title: 'incwave',
      subtitle: 'Music Production & Sound Design',
      description: 'We offer comprehensive music production services, from original composition and track making to BGM creation and artist support.',
      icon: 'ri-music-2-line',
      image: 'https://storage.readdy-site.link/project_files/38ba0d2e-b3d0-4053-be77-c6b79537f441/8d4ee39e-ab74-4be2-9533-64f80faac6a7_incwave_webcard.jpg?v=09ee42e1dbc6b058d94603553e71b10b',
      features: ['Original Composition', 'Track Making', 'BGM Production', 'Artist Support']
    }
  ];

  return (
    <section id="business" className="py-24 px-6 bg-gradient-to-b from-black to-slate-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 tracking-wider">BUSINESS</h2>
          <div className="w-24 h-1 bg-purple-500 mx-auto"></div>
          <p className="mt-6 text-lg text-gray-300">Two pillars pursuing creativity</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
          {businesses.map((business, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-slate-800/50 to-slate-900/50 rounded-lg overflow-hidden border border-purple-500/20 hover:border-purple-500/60 transition-all duration-500 transform hover:scale-105 shadow-xl hover:shadow-purple-500/20"
            >
              <div className="relative h-44 md:h-64 overflow-hidden">
                <img
                  src={business.image}
                  alt={business.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700"
                />

                <div className="absolute top-4 right-4 w-16 h-16 flex items-center justify-center bg-purple-600/80 rounded-full">
                  <i className={`${business.icon} text-3xl`}></i>
                </div>
              </div>

              <div className="p-8">
                <h3 className="text-2xl font-bold mb-2">{business.title}</h3>
                <p className="text-purple-400 text-sm mb-4 font-light tracking-wide">{business.subtitle}</p>
                <p className="text-gray-300 mb-6 leading-relaxed">{business.description}</p>
                
                <div className="flex flex-wrap gap-2">
                  {business.features.map((feature, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-purple-600/20 text-purple-300 text-sm rounded-full border border-purple-500/30"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
